import { useMissionsTranslation } from '../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Chip, Tooltip, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
export const shiftDetailsLocations = ['missions', 'time-tracking'];
export const ShiftDetails = (props) => {
    const { actionsComponent, startTime, stopTime, shiftId, statusBadgeLabel, noPadding, analyticsComponent, location } = props;
    const titleDataTest = location === 'time-tracking' ? 'mission' : 'county';
    const title = location === 'time-tracking' ? props.missionName : props.countyName;
    const { t } = useMissionsTranslation();
    const isShiftEndingInSameDay = isShiftEndingSameDay(startTime, stopTime);
    // if past shift just show 0
    const upLgScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));
    const statusBadge = statusBadgeLabel && (React.createElement(Chip, { size: 'small', sx: {
            width: 'fit-content',
            typography: 'caption',
            backgroundColor: statusBadgeLabel === 'Approved' ? themeColors.accent.green.bold : themeColors.accent.orange.base,
            color: statusBadgeLabel === 'Approved' ? themeColors.text.inverse : themeColors.text.main,
        }, label: statusBadgeLabel, "data-test": 'volunteer-status-chip' }));
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexGrow: 1,
            gap: 2,
            alignItems: 'center',
            flexWrap: { xs: 'wrap', lg: 'unset' },
        }, "data-test": `shift-details-${shiftId}` },
        React.createElement(Box, { sx: {
                display: 'flex',
                width: { xs: '100%', lg: '40%' },
                alignItems: { sm: 'center' },
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: { xs: 'space-between', lg: 'start' },
                flexGrow: 1,
            } },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    pl: !noPadding ? { xs: 5, lg: 0 } : undefined,
                    width: { xs: '100%', sm: '50%' },
                } },
                React.createElement(Box, { sx: {
                        display: 'flex',
                        whiteSpace: 'nowrap',
                        flexDirection: 'column',
                        gap: 1,
                    } },
                    React.createElement(Box, { sx: { display: 'flex', gap: 1, alignItems: 'center' } },
                        React.createElement(Typography, { variant: 'subtitle2', "data-test": 'date' }, t('date', { value: startTime })),
                        !isShiftEndingInSameDay && (React.createElement(Tooltip, { enterTouchDelay: 0, title: React.createElement(Typography, { fontSize: 'small' }, t('missions.shiftEndingNextDayTooltip')), placement: 'bottom-start', "data-test": 'tooltip' },
                            React.createElement(InfoOutlinedIcon, { fontSize: 'small', color: 'primary' }))),
                        !upLgScreen && statusBadge),
                    React.createElement(Typography, { sx: { color: (theme) => theme.palette.grey[700] }, variant: 'overline', "data-test": 'time' },
                        t('time', { value: startTime }),
                        " - ",
                        t('time', { value: stopTime })),
                    upLgScreen && statusBadge)),
            React.createElement(Typography, { variant: 'body2', "data-test": titleDataTest, sx: { whiteSpace: 'pre-wrap', maxWidth: '234px' } }, title)),
        React.createElement(Box, { sx: {
                display: 'flex',
                gap: 2,
                flexDirection: { xs: 'column', sm: 'row' },
                width: { xs: '100%', lg: '40%', xl: '50%' },
            }, "data-test": 'icons-component' }, analyticsComponent),
        actionsComponent && (React.createElement(Box, { sx: {
                display: 'flex',
                justifyContent: 'flex-end',
                width: { xs: '100%', lg: '20%', xl: '25%' },
                flexGrow: 1,
            }, "data-test": 'actions' }, actionsComponent))));
};
function isShiftEndingSameDay(startTime, stopTime) {
    return new Date(startTime).toDateString() === new Date(stopTime).toDateString();
}
